import { Grid } from '@elliemae/ds-grid';
import { styled, createGlobalStyle } from '@elliemae/ds-system';

export const BodyFix = createGlobalStyle`
    body{
        ${(props) => (props.isOpen ? 'overflow: hidden;' : '')};
    }
`;
export const ModalBox = styled(Grid)`
  width: 100%;
  background: ${(props) => props.theme.colors.neutral['000']};
  max-height: ${(props) => props.maxHeight};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
`;
export const ModalPosition = styled(Grid)`
  z-index: ${(props) => props.zIndex};
  background: ${(props) => props.theme.colors.neutral['000']};
  position: absolute;
  top: 12.5%;
  width: 80%;
  left: 10%;
`;

export const BackShadow = styled(Grid)`
  z-index: ${(props) => props.zIndex};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  overflow: hidden;
`;

export const ModalIcon = styled(Grid)`
  padding-top: 24px;
  justify-content: center;
  span.em-ds-icon svg,
  svg:not([fill]) {
    fill: ${(props) => props.theme.colors.warning[600]};
  }
`;

export const ModalTitle = styled(Grid)`
  padding-top: 24px;
  font-size: 22px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.neutral[600]};
  text-align: center;
`;
export const ModalDescription = styled(Grid)`
  padding-top: ${(props) => props.theme.space.xxs};
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.neutral[500]};
  text-align: center;
`;
